import './App.css';
import { footer } from './components/Data';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import './fonts/fonts.css';
import Home from './pages/Home/Home';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import { Routes, Route } from 'react-router-dom';

function App() {
  return (
    <>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/terms" element={<Terms/>} />
      </Routes>
      <Footer {...footer}/>
    </>
  );
}

export default App;
